import {makeAnimated} from 'vue-graphics/animation'

export default makeAnimated({
  functional: true,
  props: ['value', 'formatted'],
  render (h, {data, props}) {
    return h('h1', data, props.formatted(props.value))
  }
}, ['value'])
